import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StorageItem } from '@vsolv/packages/storage/domain';
import { BehaviorSubject, firstValueFrom, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private http = inject(HttpClient);

  _openedItem = new BehaviorSubject<StorageItem.Model | null>(null);

  get openedItem() {
    return this._openedItem.pipe(
      map(item => (item ? { ...item, processingResults: [...(item.processingResults ?? [])] } : null))
    );
  }

  async uploadFile(
    data: StorageItem.UploadCommandRequest<File>,
    customUploadEndpoint?: string | null
  ): Promise<StorageItem.UploadCommandResponse> {
    const formData = new FormData();
    for (const key in data) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const value = (data as any)[key];
      if (value !== undefined && value !== null) formData.set(key, value);
    }

    return await firstValueFrom(
      this.http.post<StorageItem.UploadCommandResponse>(customUploadEndpoint ?? '/api/storage', formData)
    );
  }

  list(dto?: StorageItem.ListRequest): Promise<StorageItem.ListResponse> {
    return firstValueFrom(this.http.get<StorageItem.ListResponse>('/api/storage', { params: { ...dto } }));
  }

  retrieve(id: string): Promise<StorageItem.Model> {
    return firstValueFrom(this.http.get<StorageItem.Model>(`/api/storage/${id}`));
  }

  delete(id: string, customEndpoint?: string | null): Promise<void> {
    let endpoint = customEndpoint ?? '/api/storage';
    if (endpoint.endsWith('/')) endpoint = endpoint.slice(0, -1);

    return firstValueFrom(this.http.delete<void>(`${endpoint}/${id}`));
  }

  update(id: string, dto: Omit<StorageItem.UpdateRequest, 'itemId'>, customEndpoint?: string | null) {
    let endpoint = customEndpoint ?? '/api/storage';
    if (endpoint.endsWith('/')) endpoint = endpoint.slice(0, -1);

    return firstValueFrom(this.http.patch<StorageItem.UpdateResponse>(`${endpoint}/${id}`, dto));
  }
}
